module.exports = __webpack_public_path__ + "static/Groupe-2-ddf2ab8f7c3d100445e7e3338e330f41.png";